import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import {
  fetchSnakeByName,
  revampFetchSnakeByName,
} from '@terminal/services/overview-widget/overview-widget-service';

const QUERY_KEY_FETCH_SNAKE_BY_NAME = 'QUERY_KEY_FETCH_SNAKE_BY_NAME';
const QUERY_KEY_FETCH_SNAKE_BY_NAME_REVAMP_V3 =
  'QUERY_KEY_FETCH_SNAKE_BY_NAME_REVAMP_V3';

/**
 * @deprecated
 */
export const useFetchSnakeByName = (
  snake: string,
  horizonNumberOfDays?: number,
  fromDate?: string,
  isDisabled?: boolean
) =>
  useQuery({
    queryKey: [
      QUERY_KEY_FETCH_SNAKE_BY_NAME,
      snake,
      horizonNumberOfDays,
      fromDate,
    ],
    queryFn: ({ signal }) =>
      fetchSnakeByName(snake, horizonNumberOfDays, fromDate, signal),
    select: data => {
      return {
        tsData: data.data?.result.data,
        meta: data.data?.meta,
      };
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !isDisabled,
  });

export const useRevampFetchSnakeByName = (
  snake: string,
  horizonNumberOfDays?: number,
  fromDate?: string,
  isDisabled?: boolean
) =>
  useQuery({
    queryKey: [
      QUERY_KEY_FETCH_SNAKE_BY_NAME_REVAMP_V3,
      snake,
      horizonNumberOfDays,
      fromDate,
    ],
    queryFn: ({ signal }) =>
      revampFetchSnakeByName(snake, horizonNumberOfDays, fromDate, signal),
    select: data => {
      return {
        tsData: data.data?.result.data,
        meta: data.data?.meta,
      };
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !isDisabled,
  });
